import {LayoutFontSize} from "../../../layout/ui/@const";

const FONT_SIZE_DEFAULT = {
    '--font-size-default' : '14px',
    '--font-size-small'   : '13px',
    '--font-size-tiny'    : '12px',
    '--font-size-micro'   : '11px', // used with uppercase in ui5-grid-header
    '--font-size-bigger'  : '15px',

    '--font-size-h1'      : '24px',
    '--font-size-h2'      : '20px',
    '--font-size-h3'      : '17px',
}

const FONT_SIZE_SMALL = {
    '--font-size-default' : '13px',
    '--font-size-small'   : '12px',
    '--font-size-tiny'    : '11px',
    '--font-size-micro'   : '11px', // used with uppercase in ui5-grid-header
    '--font-size-bigger'  : '15px',

    '--font-size-h1'      : '24px',
    '--font-size-h2'      : '20px',
    '--font-size-h3'      : '16px',
}

const FONT_SIZES = {
    'small'     : FONT_SIZE_SMALL,
    'default'   : FONT_SIZE_DEFAULT
}


export default class FontSize {

    public currentSize : LayoutFontSize = LayoutFontSize.DEFAULT

    constructor(initFontSize: LayoutFontSize) {
        // this.currentSize = null
        this.setFontSize(initFontSize)
    }

    setFontSize(fontSize : LayoutFontSize) {

        if (fontSize===this.currentSize) return;

        // make sure palette exists
        if (!FONT_SIZES[fontSize]) fontSize = LayoutFontSize.DEFAULT

        this.currentSize = fontSize;
        this.applyDOMCssVariables();
    }

    applyDOMCssVariables() {

        // New. This is creating a style tag and setting root variables in it.
        const STYLE_ID = 'dynamic-font-size-vars'

        const sizeConfig = FONT_SIZES[this.currentSize]

        let styleTag = document.getElementById(STYLE_ID)

        if (!styleTag) {
            styleTag = document.createElement('style')
            styleTag.id = STYLE_ID
            document.head.appendChild(styleTag)
        }

        const cssVars = Object.entries(sizeConfig)
            .map(([key, value]) => `${key}: ${value};`)
            .join('\n')

        styleTag.textContent = `
            html:root {
                ${cssVars}
            }
        `


        // const sizeConfig = FONT_SIZES[this.currentSize]
        // const root = document.querySelector(':root');
        //
        // _.map(sizeConfig, (value, key)=>{
        //     // console.log(">", value, key)
        //
        //     // @ts-ignore
        //     root.style.setProperty(key, value)
        // })

    }

    fontSizes(): LayoutFontSize[] {
        return [
            LayoutFontSize.SMALL,
            LayoutFontSize.DEFAULT
        ]
    }
}
